"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ToolNavigator;
var _react = _interopRequireWildcard(require("react"));
var _Popover = _interopRequireDefault(require("@mui/material/Popover/Popover.js"));
var _List = _interopRequireDefault(require("@mui/material/List/List.js"));
var _ListItem = _interopRequireDefault(require("@mui/material/ListItem/ListItem.js"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography/Typography.js"));
var _Button = _interopRequireDefault(require("@mui/material/Button/Button.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _Architect = _interopRequireDefault(require("./Architect"));
var _Designer = _interopRequireDefault(require("./Designer"));
var _Organizer = _interopRequireDefault(require("./Organizer"));
var _Viewer = _interopRequireDefault(require("./Viewer"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _makeStyles.default)(({
  spacing
}) => ({
  item: {
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      marginRight: spacing()
    }
  }
}));
const toolSettings = {
  architect: {
    icon: _Architect.default,
    text: 'Architect'
  },
  organizer: {
    icon: _Organizer.default,
    text: 'Organizer'
  },
  designer: {
    icon: _Designer.default,
    text: 'Designer'
  },
  viewer: {
    icon: _Viewer.default,
    text: 'Viewer'
  }
};
function ToolNavigator({
  tools,
  tool
}) {
  const [open, setOpen] = (0, _react.useState)(false);
  const anchorRef = (0, _react.useRef)(null);
  const classes = useStyles({});
  const handleOpen = tool => () => {
    window.open(tools[tool], '_blank');
    setOpen(false);
  };
  const ToolIcon = toolSettings[tool].icon;
  const toolText = toolSettings[tool].text;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
      size: "small",
      ref: anchorRef,
      onClick: () => setOpen(true),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: classes.item,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(ToolIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "h5",
          children: toolText
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandMore.default, {})]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popover.default, {
      anchorEl: anchorRef.current,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      open: open,
      onClose: () => setOpen(false),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_List.default, {
        children: [tools.architect && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem.default, {
          dense: true,
          button: true,
          className: classes.item,
          onClick: handleOpen('architect'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Architect.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: "subtitle1",
            children: "Open Architect"
          })]
        }), tools.organizer && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem.default, {
          dense: true,
          button: true,
          className: classes.item,
          onClick: handleOpen('organizer'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Organizer.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: "subtitle1",
            children: "Open Organizer"
          })]
        }), tools.designer && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem.default, {
          dense: true,
          button: true,
          className: classes.item,
          onClick: handleOpen('designer'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Designer.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: "subtitle1",
            children: "Open Designer"
          })]
        }), tools.viewer && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ListItem.default, {
          dense: true,
          button: true,
          className: classes.item,
          onClick: handleOpen('viewer'),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Viewer.default, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
            variant: "subtitle1",
            children: "Open Viewer"
          })]
        })]
      })
    })]
  });
}